import type { DateTime, } from "luxon";

/** a UNIX epoch timestamp in seconds since 1970-01-01 00:00:00 UTC */
export declare type EpochSeconds = number & { };

/** a UNIX epoch timestamp in milliseconds since 1970-01-01 00:00:00 UTC */
export declare type EpochMilliseconds = number & { };

/** a duration in seconds */
export declare type SecondsDuration = number & { };

/** a duration in milliseconds */
export declare type MillisecondsDuration = number & { };

/** ISO 8601 date string */
export declare type ISOTimeString = string & { };

export declare type TimeIdentifier = ISOTimeString | Date | DateTime | EpochSeconds | EpochMilliseconds;

export const isISOTimeString = ( value: unknown ): value is ISOTimeString => {
	return typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value);
}


const MIN_SECONDS = -6940032000;      // Jan 1, 1750 in seconds
const MAX_SECONDS = 15146044800;      // Jan 1, 2450 in seconds

export const isEpochMilliseconds = ( value: unknown, ): value is EpochMilliseconds => {
	return typeof value === "number" && value >= MIN_SECONDS * 1000 && value <= MAX_SECONDS * 1000;
}

export const isEpochSeconds = ( value: unknown, ): value is EpochSeconds => {
	return typeof value === "number" && value >= MIN_SECONDS && value <= MAX_SECONDS;
}
